<div class="viewer-bloc" (touchstart)="touchModel3d()">
  <app-model-viewer-urbasee
    width="100%"
    height="100%"
    [project-id]="projectId"
    [token]="token"
    [main-element]="mainElement"
    [main-element-variant]="mainElementVariant"
    [accessory-element]="accessoryElement"
    [accessory-element-variant]="accessoryElementVariant"
    [force-ar]="forceAr"
    (elements-loaded)="elementsLoaded($event)"
    (project-loaded)="projectLoaded($event)"
    (textures-categories-loaded)="textureCategoriesLoaded($event)"
    (keywords-loaded)="keywordsLoaded($event)"
    (model-viewer-ready)="modelViewerReady($event)"
    (can-activate-ar)="onCanActivateAr($event)"
  ></app-model-viewer-urbasee>
</div>

<!-- NOUVEAUX MENUS -->

<div class="menu-bloc">
  <!-- Couleur principale -->
  <div class="menu-main">
    <div
      class="main-bloc"
      [title]="'structure_color_title' | transloco"
      (click)="toggleMenuMainElementVariant()"
      [ngClass]="{ selected: menuMainElementVariantOpened }"
    >
      <app-keyword-preview
        [keyword-name]="mainElementName"
        [keywords]="keywords"
      ></app-keyword-preview>
    </div>

    <!-- Accessoire -->
    <div
      class="main-bloc"
      [title]="'accessory_title' | transloco"
      (click)="toggleMenuAccessoryElement()"
      [ngClass]="{ selected: menuAccessoryElementOpened }"
    >
      <app-keyword-preview
        [keyword-name]="'Accessory'"
        [keywords]="keywords"
      ></app-keyword-preview>
    </div>
  </div>

  <!-- accesories -->
  <div class="menu-child" *ngIf="menuAccessoryElementOpened">
    <div
      *ngFor="let accessory of accessories | filterElementEnabled"
      class="child-bloc"
      (click)="enableAccessoryElement(accessory)"
      [title]="accessory.i18ns | i18n : locale : accessory.name"
      [ngClass]="{ selected: accessory === accessoryElement }"
    >
      <div class="button-content">
        <app-keyword-preview
          [keyword-name]="accessory.name"
          [keywords]="keywords"
          [alternative-name]="accessory.i18ns | i18n : locale : accessory.name"
        ></app-keyword-preview>
      </div>
    </div>
  </div>

  <!-- accessories color variants -->
  <div class="menu-child" *ngIf="menuAccessoryElementOpened">
    <div
      *ngFor="
        let variant of accessories
          | extractVariantsForElement : accessoryElement!
      "
      class="child-bloc"
      (click)="setAccessoryElementVariant(variant)"
      [ngClass]="{ selected: variant === accessoryElementVariant }"
    >
      <div
        class="button-content"
        [title]="variant.i18ns | i18n : locale : variant.name"
      >
        <app-variant-preview
          [variant]="variant"
          [texture-categories]="textureCategories"
        ></app-variant-preview>
      </div>
    </div>
  </div>

  <!-- main color variants -->
  <div class="menu-child">
    <ng-container *ngIf="menuMainElementVariantOpened">
      <div
        class="child-bloc"
        *ngFor="let projectVariant of projectVariants | filterEnabled"
        (click)="setMainElementVariant(projectVariant)"
        [ngClass]="{ selected: projectVariant === mainElementVariant }"
      >
        <div
          class="button-content"
          [title]="projectVariant.i18ns | i18n : locale : projectVariant.name"
        >
          <app-variant-preview
            [variant]="projectVariant"
            [texture-categories]="textureCategories"
          >
          </app-variant-preview>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Boutons AR -->
<div class="button-ar-bloc" (click)="activateAr()">
  <svg
    version="1.1"
    id="view_x5F_in_x5F_AR_x5F_icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    xml:space="preserve"
  >
    <rect id="Bounding_Box" x="0" y="0" fill="none" width="24" height="24" />
    <g id="Art_layer">
      <path d="M3,4c0-0.55,0.45-1,1-1h2V1H4C2.35,1,1,2.35,1,4v2h2V4z" />
      <path d="M20,3c0.55,0,1,0.45,1,1v2h2V4c0-1.65-1.35-3-3-3h-2v2H20z" />
      <path d="M4,21c-0.55,0-1-0.45-1-1v-2H1v2c0,1.65,1.35,3,3,3h2v-2H4z" />
      <path d="M20,21c0.55,0,1-0.45,1-1v-2h2v2c0,1.65-1.35,3-3,3h-2v-2H20z" />
      <g>
        <path
          d="M18.25,7.6l-5.5-3.18c-0.46-0.27-1.04-0.27-1.5,0L5.75,7.6C5.29,7.87,5,8.36,5,8.9v6.35c0,0.54,0.29,1.03,0.75,1.3
			l5.5,3.18c0.46,0.27,1.04,0.27,1.5,0l5.5-3.18c0.46-0.27,0.75-0.76,0.75-1.3V8.9C19,8.36,18.71,7.87,18.25,7.6z M7,14.96v-4.62
			l4,2.32v4.61L7,14.96z M12,10.93L8,8.61l4-2.31l4,2.31L12,10.93z M13,17.27v-4.61l4-2.32v4.62L13,17.27z"
        />
      </g>
    </g>
  </svg>
</div>

<div *ngIf="canCloseIframe" class="button-close-bloc" (click)="closeIframe()">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-x-lg"
    viewBox="0 0 16 16"
  >
    <path
      d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
    />
  </svg>
</div>

<div class="loading-bloc" *ngIf="!isReady">
  <p>{{ "loading_text" | transloco }}</p>
</div>
